import {useLocation} from 'react-router'
import {ideationApi} from '../../../../../../api/ideationApi'
import styles from './IdeationSummary.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../../Translation/English/ideation'

export const IdeationSummary: React.FC = () => {
  const wt = useWt()
  const {search} = useLocation()
  const ideationId = search ? search.substring(1) : ''
  const {data: insights} = ideationApi.useIdeationInsights(ideationId)

  return (
    <div className={styles.ideationSummary}>
      <div className="ideation-section-title">{wt(IDEATION.summary)}</div>
      <div className={styles.ideationSummaryText}>{insights?.summary}</div>
    </div>
  )
}
